import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Aos from "aos";
import 'aos/dist/aos.css'
import Carousel from '../components/Carousel';
import Presentation from '../components/Presentation';
import PartnersCarousel from '../components/Partners';
import bms from '../assets/illustration/salwa-bms-love.JPG';
import joel from '../assets/illustration/joel-watch-color.jpg';


const Home = () => {

  useEffect(() => {
    Aos.init();
  }, [])

  return (

    <main>
      <section className="presentation-section">
        <Presentation />
        <div className='catch-phrase'>
          <p>
            BMS influence l'esport, l'esport influence le monde
          </p>
          <div>
            <Link to="/about" className='about-btn'>En savoir plus</Link>
          </div>
        </div>
      </section>
      <div className="separator w-full max-w-6xl mx-auto mb-[100px] px-4">
        <hr className="border-t-2 border-[#e0e0e0] opacity-75" />
      </div>
      <section className='shop-section'>
        <div>
          <h1>Découvre notre nouvelle collection</h1>
          <Carousel />
        </div>
      </section>
      <section className='team-section'>
        <h1>Unis sous la même bannière</h1>
        <div className='presentation-team-section'>
          <div className='txt-team-section'>
            <p>
              Chez BMS, nous ne sommes pas seulement une équipe, nous sommes une <b>famille</b>.
              <br></br>
              <br></br>
              Et dans cette famille, les supporters font partie intégrante de l'aventure. Leur énergie, leurs encouragements et leur passion sont ce qui nous propulse vers la <b>victoire</b>.
              <br></br>
              <br></br>
              Dans la Black Mafia, chaque membre, qu’il soit joueur ou supporter, contribue à notre <b>ascension</b>. 
              <br></br>
              <br></br>
              Ensemble, on avance, on gagne, on domine.
            </p>
            <div className='catch-phrase'>
              <p>
                #BlackMafiaCommeBMS
              </p>
              <div>
                <Link to="/crew" className='about-btn'>Découvre l'équipe</Link>
              </div>
            </div>
          </div>
            <div>
              <img src={bms} alt="" />
            </div>
        </div>
      </section>
      <section className='partners-section'>
        <PartnersCarousel />
      </section>
      <section className='academy-section'>
        <h1>Former le présent pour dominer le futur</h1>
        <div className='presentation-academy-section'>
          <div className='txt-academy-section'>
              <p>
                Au-delà du simple développement des compétences en jeu, on forge les <b>champions de demain</b> à tous les niveaux.
                <br></br>
                <br></br>
                On met toutes les chances de ton côté. Les joueurs qui nous rejoignent évoluent à leur rythme avec tous les outils pour exploiter leur plein potentiel.
                <br></br>
                Notre équipe crée l'environnement idéal pour que chacun puisse se dépasser et atteindre ses objectifs.
                <br></br>
                <br></br>
                Rejoindre BMS, c'est entrer dans un écosystème taillé pour la <b>performance</b>, où chaque détail est optimisé pour t'emmener au <b>sommet</b>.
              </p>
              <div className='catch-phrase'>
                <p>
                  L'excellence comme destination
                </p>
                <div>
                  <Link to="/academy" className='about-btn'>Rejoins l'Académie</Link>
                </div>
              </div>
          </div>
          <div className='img-academy-section'>
            <img src={joel} alt="" />
          </div>
        </div>
      </section>
    </main>
  );
}

export default Home;